import React, { useEffect, useState } from 'react';
import './Celebration.css';

interface CelebrationProps {
  isVisible: boolean;
  word: string;
  onComplete: () => void;
}

const Celebration: React.FC<CelebrationProps> = ({ isVisible, word, onComplete }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        onComplete();
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onComplete]);

  if (!show) return null;

  return (
    <div className="celebration-container">
      <div className="celebration-text">
        <span className="celebration-emoji">🎉</span>
        <span className="celebration-word">{word}</span>
        <span className="celebration-emoji">🎉</span>
      </div>
    </div>
  );
};

export default Celebration;
